import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sailing-video-analytics-poster.webp")